import type { MerchantRole } from '../shared/types';

export function getUserRole({
  merchantId,
  roles,
}: {
  merchantId: string;
  roles: MerchantRole[];
}): string {
  const role = roles.find((r) => r.merchant.id === merchantId);
  return role ? role.name : 'unknown';
}
